import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput
} from "@mui/material";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import React, { useEffect, useRef, useState } from "react";
import { DateTimeField, LocalizationProvider } from "@mui/x-date-pickers";
import { getCostTypes } from "../../actions/costs";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { connect, useStore } from "react-redux";
import { Link, Navigate, useLocation } from "react-router-dom";
import { makeStyles } from "tss-react/mui";
import { CreateReport, UpdateReport } from "../../actions/notification";
import { updateCost } from "../../actions/costs";
import { getNotification } from "../../actions/notification";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import CircularProgress from "@mui/material/CircularProgress";
import Paper from "@mui/material/Paper/Paper";
import Typography from "@mui/material/Typography/Typography";
import moment from "moment";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import NotificationAttachments, {
  persistAttachmentMetadataUpdates
} from "../NotificationDetailsPage/NotificationAttachments";
import axios, * as others from "axios";
import store from "../../store";
// import { getUnits } from "../../shared-functions/units";
import { UpdateNotification } from "../../actions/notification";
import { getItem } from "../../utils/DataProtection";
import { UpdateMaintenanceTask } from "../../actions/machines";
import { getUnits } from "../../actions/counters";
import { GermanNumericFormat } from "../../components/GermanNumberInput";

let locale = "de";

export default connect(
  ({
    enterprises,
    isAuthUser,
    machines,
    i18n,
    notification,
    costtypes,
    units
  }) => ({
    enterprises,
    isAuthUser,
    machines,
    i18n,
    notification,
    costtypes,
    getCostTypes,
    units
  }),
  {
    CreateReport,
    UpdateReport,
    UpdateMaintenanceTask,
    getCostTypes,
    getNotification,
    updateCost,
    UpdateNotification,
    getUnits
  }
)(props => {
  const stundenCostNodeIds = [
    "247fn://247uptime.io/8e0ce52b-c1ab-4104-834d-758a167e179f",
    "247fn://247uptime.io/cc42db6e-243f-4606-a38a-780fe1b35a1e"
  ];
  const euroCostNodeIds = [
    "247fn://247uptime.io/95f0ccfc-7943-4f87-b969-d0796f53dd0e",
    "247fn://247uptime.io/f0e5f689-baad-4494-970d-cffc842ae794",
    "247fn://247uptime.io/f7fcdb17-0a9c-40e2-857d-712baa2cd745"
  ];

  const euro_unit = {
    unitId: "EUR",
    namespace: "https://www.iso.org/iso-4217-currency-codes"
  };

  const stunden_unit = {
    unitId: "4740434",
    namespace: "https://247factorynet.com/unitcodes"
  };

  const existingCounterValue =
    props.notification.notification.hasmaintenancetask[0].maintenancetask
      .triggeringevent[4] ||
    props.notification.notification.hasmaintenancetask[0].maintenancetask
      .triggeringevent[1] +
      props.notification.notification.hasmaintenancetask[0].maintenancetask
        .triggeringevent[3] ||
    0;

  const counterType =
    props.notification.notification.hasmaintenancetask[0].maintenancetask
      .triggertype;

  const i18n = props.i18n;
  const store = useStore().getState();

  const isNextDateChanged = useRef(false); // Ref to track if user changed the nextdueat date
  const isCounterValueChanged = useRef(false); // Ref to track if user changed the counter value

  const [comment, setcomment] = useState("");
  const [counterUnit, setCounterUnit] = useState("");

  const [nextError, setNextError] = useState("");

  const [navigate, setNavigate] = useState(false);
  const [latestCounterValue, setLatestCounterValue] = useState(0);

  const [nextRepititionCycles, setNextRepititionCycles] = useState(
    existingCounterValue || 0
  );

  // let location = useLocation();
  /* console.log(props, "props?"); */

  const [execution, setexecution] = React.useState(
    moment(Date.now()).format("YYYY-MM-DD")
  );
  const [n_time, setn_time] = useState();
  const [nodeId, setNodeId] = useState();

  useEffect(() => {
    if (props && props?.pageType == "edit") {
      setexecution(props?.date);
      setn_time(props?.time);
      setcomment(props?.comment);
      setNodeId(nodeId);
    }
    props.getCostTypes("", "COST_TYPES");
  }, []);

  const [noti_loader, setnoti_loader] = useState(false);

  /*
   * Styles
   */
  const useStyles = makeStyles()(theme => ({
    elevatedSection: {
      ...theme.elevatedSection
    },
    sectionHeader: {
      ...theme.sectionHeader
    },
    sectionDivider: {
      marginBottom: 28
    }
  }));
  const { classes } = useStyles(props, {
    props: props
  });

  const [noti_image_data, setnoti_image_data] = useState([]);
  const [noti_video_data, setnoti_video_data] = useState([]);
  const [noti_docs_data, setnoti_docs_data] = useState([]);
  const [persistedAttachmentUpdates, setPersistedAttachmentUpdates] = useState(
    []
  );

  const receiveChildValueAttachment = (
    images,
    videos,
    docs,
    from,
    persistedChanges
  ) => {
    setnoti_image_data(images);
    setnoti_video_data(videos);
    setnoti_docs_data(docs);
    setPersistedAttachmentUpdates(persistedChanges || []);
  };

  const handleDate = e => {
    setexecution(e.target.value);
  };

  const handletime = e => {
    setn_time(e.target.value);
  };

  const getDateFromTimestamp = unixTimeStamp => {
    let date = new Date(unixTimeStamp);
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())
    );
  };
  const getTimeFromTimestamp = unixTimeStamp => {
    let date = new Date(unixTimeStamp);
    return (
      date.getHours() +
      ":" +
      (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
    );
  };

  const creation_date = getDateFromTimestamp(Date.now());
  const creation_time = getTimeFromTimestamp(Date.now());

  const { units } = props;

  let userProfile = store.userProfile;

  const [realName, setRealName] = useState(
    (props && props.auther) ||
      userProfile?.user?.givenname + " " + userProfile?.user?.surname
  );

  const [textFields, setTextFields] = useState([]);
  const [fullname, setFullName] = useState(
    (props && props.authorsignature) || ""
  );

  const [createdDate, setCreatedDate] = useState(
    props?.pageType === "edit"
      ? moment.unix(props?.created / 1000).format("YYYY-MM-DD")
      : moment(Date.now()).format("YYYY-MM-DD")
  );

  // console.log(pro,"created")

  const [nextDate, setNextDate] = useState(
    moment.unix(props?.nextdueat / 1000).format("YYYY-MM-DD")
  );

  const handleCreatedDateChange = e => {
    setCreatedDate(e.target.value);
  };

  const handleNextDateChange = e => {
    isNextDateChanged.current = true; // Mark that user has changed the date
    setNextDate(e.target.value);
  };

  const submitForm = async e => {
    e.preventDefault();
    // setnoti_loader(true);

    //attachments
    const attachmentObject = {
      HEADER: {
        LANGUAGE_VERSION: "1.0.0"
      },

      OBJECTS: []
    };
    let urlArray = []; // unknown # of urls (1 or more)
    var fileurls = [];
    let promiseArray = [];
    var attachments = [];
    const config = {
      headers: {
        "Content-Type": "application/octet-stream",
        "Access-Control-Allow-Origin": "*"
      }
    };
    if (noti_image_data.length > 0) {
      for (var i = 0; i < noti_image_data.length; i++) {
        if (!noti_image_data[i].uploaded) {
          promiseArray.push(
            axios.put(noti_image_data[i].url, noti_image_data[i].image, config)
          );
        }
        const image = {
          nodeid: noti_image_data[i].nodeid,
          fileid: noti_image_data[i].fileid,
          mimetype: noti_image_data[i].mime,
          bucketid: noti_image_data[i].bucketid,
          fileversion: noti_image_data[i].fileversion,
          title:
            noti_image_data[i].title ||
            noti_image_data[i].image?.name?.split(".")[0],
          description: noti_image_data[i].description || ""
        };
        attachments.push(image);
      }
    }

    if (noti_video_data.length > 0) {
      for (var i = 0; i < noti_video_data.length; i++) {
        if (!noti_video_data[i].uploaded) {
          promiseArray.push(
            axios.put(noti_video_data[i].url, noti_video_data[i].image, config)
          );
        }
        const image = {
          nodeid: noti_video_data[i].nodeid,
          fileid: noti_video_data[i].fileid,
          mimetype: noti_video_data[i].mime,
          bucketid: noti_video_data[i].bucketid,
          fileversion: noti_video_data[i].fileversion,
          title:
            noti_video_data[i].title ||
            noti_video_data[i].image?.name?.split(".")[0],
          description: noti_video_data[i].description || ""
        };
        attachments.push(image);
      }
    }
    if (noti_docs_data.length > 0) {
      for (var i = 0; i < noti_docs_data.length; i++) {
        if (!noti_docs_data[i].uploaded) {
          promiseArray.push(
            axios.put(noti_docs_data[i].url, noti_docs_data[i].image, config)
          );
        }
        const image = {
          nodeid: noti_docs_data[i].nodeid,
          fileid: noti_docs_data[i].fileid,
          mimetype: noti_docs_data[i].mime,
          bucketid: noti_docs_data[i].bucketid,
          fileversion: noti_docs_data[i].fileversion,
          title: noti_docs_data[i].title,
          description: noti_docs_data[i].description
        };
        attachments.push(image);
      }
    }

    const response = await axios.all(promiseArray).then(function(results) {
      var ok = results.map(r => r.data);
      return ok;
    });
    const created = Date.now();
    const usernodeid = JSON.parse(getItem("usernodeid"));
    const notificationnodeid = props?.notificationnodeid;

    const datetime = execution + " " + n_time + ":00.999";
    var dt = new Date(datetime);
    var executed = dt.getTime();
    if (isNaN(executed) || executed == null || executed == undefined) {
      if (execution == undefined && n_time != undefined) {
        const datetime = creation_date + " " + n_time + ":00.999";
        var dt = new Date(datetime);
        executed = dt.getTime();
      } else if (execution != undefined && n_time == undefined) {
        const datetime = creation_date + " " + creation_time + ":00.999";
        var dt = new Date(datetime);
        executed = dt.getTime();
      } else {
        executed = Date.now();
      }
    }
    const lang = "de";

    await persistAttachmentMetadataUpdates(persistedAttachmentUpdates, lang);

    let nextdueat = isNextDateChanged ? nextDate : props.nextdueat;

    let tempNextRepititionCycle = ("" + nextRepititionCycles)?.replace(
      ",",
      "."
    );

    tempNextRepititionCycle = tempNextRepititionCycle?.replace(".", "");

    if (tempNextRepititionCycle == existingCounterValue) {
      isCounterValueChanged.current = false;
    }
    if (Date.parse(nextdueat) == props.nextdueat) {
      isNextDateChanged.current = false;
    }

    let newCounterValue =
      isCounterValueChanged && tempNextRepititionCycle !== existingCounterValue
        ? parseFloat(tempNextRepititionCycle || 0)
        : existingCounterValue || 0;

    // let next_counter_value = props.

    if (props?.pageType == "edit") {
      const attachmentType = "Create";
      const reportnodeid = props?.reportnodeid;
      let authorsignature = fullname;
      let created = moment(createdDate).format("X") * 1000;

      let payload = {
        lang,
        executed,
        comment,
        authorsignature,
        created,
        reportnodeid,
        attachmentType,
        attachments
      };

      if (isCounterValueChanged.current || isNextDateChanged.current) {
        payload.maintenancetasknodeid =
          props.notification.notification.hasmaintenancetask[0].maintenancetask.nodeid;

        if (counterType == "counter") {
          if (isCounterValueChanged.current) {
            payload.triggeringevent = [
              props.notification.notification.hasmaintenancetask[0]
                .maintenancetask.triggeringevent[0],
              props.notification.notification.hasmaintenancetask[0]
                .maintenancetask.triggeringevent[1],
              props.notification.notification.hasmaintenancetask[0]
                .maintenancetask.triggeringevent[2],
              tempNextRepititionCycle -
                props.notification.notification.hasmaintenancetask[0]
                  .maintenancetask.triggeringevent[1],
              newCounterValue
            ];
          }
        }
        if (isNextDateChanged.current) {
          payload.nextdueat = Date.parse(nextdueat);
        }
      }
      props.UpdateReport(payload, "UPDATEREPORT");

      // updating Costs...
      textFields.length > 0 &&
        textFields.map(item => {
          props.updateCost({
            lang: store.language,
            nodeid: item.nodeid,
            name: item.name,
            value: isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value),
            costTypeNodeId: item.costTypeNodeId,
            hasCostSourceNodeId: item.hasCostSourceNodeId,
            specifier: item.specifier,
            unit:
              props.notification?.notification.isnotificationof[0].equipment
                ?.equipmentcurrency
          });
        });
    } else {
      const tempArray = [];
      textFields.map((item, k) => {
        tempArray.push({
          lang: store.language,
          name: item.name,
          value: parseFloat(item.value),
          specifier: "actualcost",
          costTypeNodeId: item.costTypeNodeId,
          hasCostSourceNodeId: item.hasCostSourceNodeId
        });
      });

      let authorsignature = fullname;
      let created = moment(createdDate).format("X") * 1000;

      let payload_create = {
        lang,
        executed,
        comment,
        authorsignature,
        created,
        usernodeid,
        notificationnodeid,
        attachments
      };

      if (isCounterValueChanged.current || isNextDateChanged.current) {
        payload_create.maintenancetasknodeid =
          props.notification.notification.hasmaintenancetask[0].maintenancetask.nodeid;

        if (counterType == "counter") {
          if (isCounterValueChanged.current) {
            payload_create.triggeringevent = [
              props.notification.notification.hasmaintenancetask[0]
                .maintenancetask.triggeringevent[0],
              props.notification.notification.hasmaintenancetask[0]
                .maintenancetask.triggeringevent[1],
              props.notification.notification.hasmaintenancetask[0]
                .maintenancetask.triggeringevent[2],
              tempNextRepititionCycle -
                props.notification.notification.hasmaintenancetask[0]
                  .maintenancetask.triggeringevent[1],
              newCounterValue
            ];
          }
        }
        if (isNextDateChanged.current) {
          payload_create.nextdueat = Date.parse(nextdueat);
        }
      }

      props.CreateReport(payload_create);

      // updating Costs...
      textFields.length > 0 &&
        textFields.map(item => {
          props.updateCost({
            lang: store.language,
            nodeid: item.nodeid,
            name: item.name,
            value: isNaN(parseFloat(item.value)) ? 0 : parseFloat(item.value),
            costTypeNodeId: item.costTypeNodeId,
            hasCostSourceNodeId: item.hasCostSourceNodeId,
            specifier: item.specifier,
            unit:
              props.notification?.notification.isnotificationof[0].equipment
                ?.equipmentcurrency
          });
        });

      let payload = {
        nodeid: notificationnodeid,
        status: 2,
        previousStatus: 0,
        onlyStatusUpdate: true,
        progressstarted:
          props?.notification?.notification?.progressstarted === null
            ? 0
            : props?.notification?.notification?.progressstarted,
        type: props?.notification?.notification?.type,
        closed: moment(Date.now()).unix() * 1000,
        title: props?.notification?.notification?.title,
        description: props?.notification?.notification?.description,
        equipmentnodeid:
          props?.notification?.notification?.isnotificationof &&
          props?.notification?.notification?.isnotificationof[0]?.equipment
            ?.nodeid
      };

      props.UpdateNotification(payload, "UPDATENOTIFICATIONSTATUS");
    }

    props.getNotification(
      { nodeid: props.notification?.notification?.nodeid },
      "GETSINGLENOTIFICATION"
    );

    props.setProtokolEditView(false);
    setnoti_loader(false);

    // setNavigate(true);
  };

  const handleTextFieldChange = (
    hasCostSourceNodeId,
    specifier,
    id,
    nodeid,
    costTypeNodeId,
    name,
    value
  ) => {
    setTextFields(textFields => {
      const index = textFields.findIndex(tf => tf.id === id);
      if (index === -1) {
        // text field doesn't exist yet, so create a new object
        return [
          ...textFields,
          {
            id,
            name,
            value,
            nodeid,
            costTypeNodeId,
            specifier,
            hasCostSourceNodeId
          }
        ];
      } else {
        // text field already exists, so update its value
        const updatedTextField = {
          ...textFields[index],
          name,
          value,
          nodeid,
          costTypeNodeId,
          specifier,
          hasCostSourceNodeId
        };
        return [
          ...textFields.slice(0, index),
          updatedTextField,
          ...textFields.slice(index + 1)
        ];
      }
    });
  };

  /* console.log(props.notification.notification,"====>CT") */

  let hasAuthorSigImage = props?.notification?.notification?.hasreport
    ? Object.keys(
        props?.notification?.notification?.hasreport[0]?.report
          ?.authorsignatureimage
      ).length
    : false;

  const costOrders = [
    "Kosten Teile",
    "Kosten Betriebsstoffe",
    "Kosten externe Dienstleister",
    "Stillstandszeit",
    "Personenstunden (intern)"
  ];

  useEffect(() => {
    if (units.length === 0) {
      props.getUnits("UNITS");
    }
  }, []);

  // Handle input change
  const handleNextRepititionCycleChange = event => {
    isCounterValueChanged.current = true; // Mark that user has changed the counter value
    let input = event.target.value;
    setNextRepititionCycles(input);
    // Validation: Allow only valid numbers
    const regex = locale === "en" ? /^[0-9,]*\.?[0-9]*$/ : /^[0-9.]*,?[0-9]*$/;
    if (!regex.test(input)) {
      setNextError("Ungültiges Zahlenformat");
      return;
    }
    if (+input <= 0) {
      setNextError("Wert muss >= 1 sein");
      return;
    }

    // if (+input <= props.notification.notification.hasmaintenancetask[0].maintenancetask.triggeringevent[1]) {
    //   setNextError("Wert muss > "+props.notification.notification.hasmaintenancetask[0].maintenancetask.triggeringevent[1]+" sein");
    //   return;
    // }

    setNextError(""); // Clear error if valid
    setNextRepititionCycles(formatNumber(input));
  };

  // Function to format input dynamically
  const formatNumber = input => {
    let rawNumber = input.replace(/[^0-9,.]/g, ""); // Remove invalid chars
    let parts = [];

    if (locale === "en") {
      rawNumber = rawNumber.replace(/,/g, ""); // Remove commas
      parts = rawNumber.split(".");
    } else if (locale === "de") {
      rawNumber = rawNumber.replace(/\./g, "").replace(/,/g, "."); // Handle German format
      parts = rawNumber.split(".");
    }

    let integerPart = parts[0].replace(
      /\B(?=(\d{3})+(?!\d))/g,
      locale === "en" ? "," : "."
    );
    let decimalPart = parts[1] ? parts[1].slice(0, 2) : "";

    return decimalPart
      ? `${integerPart}${locale === "en" ? "." : ","}${decimalPart}`
      : integerPart;
  };

  // useEffect(() => {

  //   if (counterType == "counter") {
  //     setNextRepititionCycles(existingCounterValue || 0);
  //   }
  // }, [counterType]);

  return (
    <>
      {navigate ? (
        <Navigate
          push
          to={
            "/machine-overview?nodeid=" +
            encodeURIComponent(
              props?.notification?.notification?.isnotificationof[0]?.equipment
                ?.nodeid
            ) +
            "&tab=1"
          }
        />
      ) : null}

      <section style={{ padding: "28px 24px" }} className="costsSection">
        <header className={classes.sectionHeader}>
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="space-between"
          >
            <Grid item>
              <Typography variant="h1">
                {props.pageType === "edit"
                  ? i18n.edit_report_title
                  : i18n.create_report__title}
              </Typography>
            </Grid>
          </Grid>
        </header>

        <form className={_s(Theme247.form)}>
          <Grid
            container
            spacing={3}
            direction="row"
            justifyContent="space-between"
          >
            <Grid item xs={12}>
              <Grid container spacing={3}>
                <Grid item xs={6}>
                  {
                    <TextField
                      id="date"
                      label={"Durchgeführt am"}
                      type="date"
                      onChange={handleDate}
                      defaultValue={
                        props?.pageType == "edit" ? props?.date : creation_date
                      }
                      className={_s(Theme247.inputField)}
                      InputLabelProps={{
                        shrink: true
                      }}
                      variant="outlined"
                    />
                  }
                </Grid>
                <Grid item xs={6}>
                  {
                    <TextField
                      id="time"
                      label={"Durchgeführt um"}
                      type="time"
                      onChange={handletime}
                      defaultValue={
                        props?.pageType == "edit"
                          ? moment(
                              props?.notification.notification.hasreport[0]
                                .report.executed
                            ).format("HH:mm")
                          : moment(Date.now()).format("HH:mm")
                      }
                      className={_s(Theme247.inputField)}
                      InputLabelProps={{
                        shrink: true
                      }}
                      inputProps={{
                        step: 300 // 5 min
                      }}
                      variant="outlined"
                    />
                  }
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <TextField
                    multiline
                    rows="5"
                    onChange={e => {
                      setcomment(e.target.value);
                    }}
                    placeholder={i18n.protocol_comments}
                    className={classes.textarea}
                    variant="outlined"
                    defaultValue={
                      props && props?.pageType == "edit" ? props?.comment : ""
                    }
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3}>
                <Grid item xs={12}>
                <br/>
                  <NotificationAttachments
                    from="notification"
                    rootNodeId={props?.notification?.notification?.nodeid}
                    // rootNodeId={props.equipmentNodeId}

                    edit={true}
                    fromChildToParentCallback={receiveChildValueAttachment}
                    specifier={"NotificationReportAttachment"}
                    nodeId={props?.reportnodeid}
                    workflowAttachments={
                      props && props?.pageType == "edit"
                        ? props?.attachments
                        : ""
                    }
                    attachmentsOf={"report"}
                  />
                </Grid>
              </Grid>

              <Divider
                variant="fullWidth"
                orientation="horizontal"
                sx={{ marginBottom: "42px" }}
              />

              <Accordion
                className="sigAccordian protokol-accordian"
                defaultExpanded
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h1" sx={{ color: "#38748D" }}>
                    {"Entstandene Aufwände"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item style={{ paddingTop: "10px" }}>
                      <div
                        className="MT_desc"
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        Der hier angegebene Aufwand kann dem Planaufwand zu
                        Analyse-Zwecken gegenübergestellt werden.
                      </div>
                    </Grid>
                  </Grid>
                  <Grid container spacing={3} style={{}}>
                    {props && props.pageType == "edit"
                      ? props.costs &&
                        props.costs?.length > 0 &&
                        props.costs.map((ct, k) => {
                          const costName = ct?.cost?.name
                            ? ct?.cost?.name
                            : ct?.cost?.hascosttype[0].costtype.name;

                          return euroCostNodeIds.includes(
                            ct?.cost?.hascosttype[0].costtype?.nodeid
                          ) ? (
                            <>
                              <Grid
                                item
                                xs={6}
                                sx={{
                                  order: costOrders.indexOf(costName)
                                }}
                              >
                                <FormControl variant="outlined">
                                  <InputLabel htmlFor="outlined-adornment-cost-edit">
                                    {costName}
                                  </InputLabel>
                                  <OutlinedInput
                                    value={ct?.cost?.value}
                                    inputComponent={GermanNumericFormat}
                                    id="outlined-adornment-cost-edit"
                                    onChange={event =>
                                      handleTextFieldChange(
                                        props.notification?.notification
                                          ?.nodeid,
                                        "actualcost",
                                        k,
                                        ct?.cost?.nodeid,

                                        ct?.cost?.hascosttype[0]?.costtype
                                          ?.nodeid,
                                        costName,
                                        event.target.value
                                      )
                                    }
                                    defaultValue={ct?.cost?.value}
                                    label={costName}
                                    variant="outlined"
                                    // style={{ width: "50%" }}
                                    InputProps={{
                                      inputProps: {
                                        pattern: "[0-9]*",
                                        inputMode: "numeric",
                                        type: "number"
                                      }
                                    }}
                                    type={"text"}
                                    endAdornment={
                                      <InputAdornment position="end">
                                        (
                                        {props.notification?.notification
                                          .isnotificationof[0].equipment
                                          ?.equipmentcurrency?.unitId || ""}
                                        )
                                      </InputAdornment>
                                    }
                                  />
                                </FormControl>
                              </Grid>
                            </>
                          ) : (
                            ""
                          );
                        })
                      : props.notification?.notification?.hascost &&
                        props.notification?.notification?.hascost.map(
                          (ct, k) => {
                            const costName = ct?.cost?.name
                              ? ct?.cost?.name
                              : ct?.cost?.hascosttype[0].costtype.name;

                            return euroCostNodeIds.includes(
                              ct?.cost?.hascosttype[0].costtype?.nodeid
                            ) ? (
                              <>
                                <Grid
                                  item
                                  xs={6}
                                  style={{
                                    order: costOrders.indexOf(costName)
                                  }}
                                >
                                  <FormControl
                                    variant="outlined"
                                    style={{ width: "100%" }}
                                  >
                                    <InputLabel htmlFor="outlined-adornment-cost-add">
                                      {costName}
                                    </InputLabel>
                                    <OutlinedInput
                                      value={ct?.cost?.value}
                                      inputComponent={GermanNumericFormat}
                                      id="outlined-adornment-cost-add"
                                      onChange={event =>
                                        handleTextFieldChange(
                                          props.notification?.notification
                                            ?.nodeid,
                                          "actualcost",
                                          k,
                                          ct?.cost?.nodeid,

                                          ct?.cost?.hascosttype[0]?.costtype
                                            ?.nodeid,
                                          costName,
                                          event.target.value
                                        )
                                      }
                                      variant="outlined"
                                      label={costName}
                                      InputProps={{
                                        inputProps: {
                                          pattern: "[0-9]*",
                                          inputMode: "numeric",
                                          type: "number"
                                        }
                                      }}
                                      type={"text"}
                                      endAdornment={
                                        <InputAdornment position="end">
                                          (
                                          {props.notification?.notification
                                            .isnotificationof[0].equipment
                                            ?.equipmentcurrency?.unitId || ""}
                                          )
                                        </InputAdornment>
                                      }
                                    />
                                  </FormControl>
                                </Grid>
                              </>
                            ) : (
                              ""
                            );
                          }
                        )}
                  </Grid>

                  <br />
                  <Divider />
                  <br />

                  <Grid container spacing={3}>
                    {props && props.pageType == "edit"
                      ? props.costs &&
                        props.costs?.length > 0 &&
                        props.costs.map((ct, k) => {
                          const costName = ct?.cost?.name
                            ? ct?.cost?.name
                            : ct?.cost?.hascosttype[0].costtype.name;

                          return (
                            <>
                              {stundenCostNodeIds.includes(
                                ct?.cost?.hascosttype[0].costtype?.nodeid
                              ) ? (
                                <Grid
                                  item
                                  xs={6}
                                  sx={{
                                    order: costOrders.indexOf(costName)
                                  }}
                                >
                                  <FormControl variant="outlined">
                                    <InputLabel htmlFor="outlined-adornment-cost-edit">
                                      {costName}
                                    </InputLabel>
                                    <OutlinedInput
                                      value={ct?.cost?.value}
                                      inputComponent={GermanNumericFormat}
                                      id="outlined-adornment-cost-edit"
                                      onChange={event =>
                                        handleTextFieldChange(
                                          props.notification?.notification
                                            ?.nodeid,
                                          "actualcost",
                                          k,
                                          ct?.cost?.nodeid,

                                          ct?.cost?.hascosttype[0]?.costtype
                                            ?.nodeid,
                                          costName,
                                          event.target.value
                                        )
                                      }
                                      defaultValue={ct?.cost?.value}
                                      label={costName}
                                      variant="outlined"
                                      // style={{ width: "50%" }}
                                      InputProps={{
                                        inputProps: {
                                          pattern: "[0-9]*",
                                          inputMode: "numeric",
                                          type: "number"
                                        }
                                      }}
                                      type={"text"}
                                      endAdornment={
                                        <InputAdornment position="end">
                                          (Stunden)
                                        </InputAdornment>
                                      }
                                    />
                                  </FormControl>
                                </Grid>
                              ) : (
                                ""
                              )}
                            </>
                          );
                        })
                      : props.notification?.notification?.hascost &&
                        props.notification?.notification?.hascost.map(
                          (ct, k) => {
                            const costName = ct?.cost?.name
                              ? ct?.cost?.name
                              : ct?.cost?.hascosttype[0].costtype.name;

                            return (
                              <>
                                {stundenCostNodeIds.includes(
                                  ct?.cost?.hascosttype[0].costtype?.nodeid
                                ) ? (
                                  <Grid
                                    className=""
                                    item
                                    xs={6}
                                    style={{
                                      order: costOrders.indexOf(costName)
                                    }}
                                  >
                                    <FormControl
                                      variant="outlined"
                                      style={{ width: "100%" }}
                                    >
                                      <InputLabel htmlFor="outlined-adornment-cost-add">
                                        {costName}
                                      </InputLabel>
                                      <OutlinedInput
                                        value={ct?.cost?.value}
                                        inputComponent={GermanNumericFormat}
                                        id="outlined-adornment-cost-add"
                                        onChange={event =>
                                          handleTextFieldChange(
                                            props.notification?.notification
                                              ?.nodeid,
                                            "actualcost",
                                            k,
                                            ct?.cost?.nodeid,

                                            ct?.cost?.hascosttype[0]?.costtype
                                              ?.nodeid,
                                            costName,
                                            event.target.value
                                          )
                                        }
                                        variant="outlined"
                                        label={costName}
                                        InputProps={{
                                          inputProps: {
                                            pattern: "[0-9]*",
                                            inputMode: "numeric",
                                            type: "number"
                                          }
                                        }}
                                        type={"text"}
                                        endAdornment={
                                          <InputAdornment position="end">
                                            (Stunden)
                                          </InputAdornment>
                                        }
                                      />
                                    </FormControl>
                                  </Grid>
                                ) : (
                                  ""
                                )}
                              </>
                            );
                          }
                        )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div style={{ marginTop: "36px" }}></div>

              <Accordion
                className="sigAccordian protokol-accordian"
                defaultExpanded
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h1" sx={{ color: "#38748D" }}>
                    {"Nächste Durchführung"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <div className="MT_desc" style={{ width: "100%" }}>
                        Das Datum wurde auf Basis des festgelegten Turnus
                        berechnet, kann aber durch Sie überschrieben werden.
                      </div>
                    </Grid>

                    <Grid
                      container
                      spacing={3}
                      sx={{ paddingLeft: "18px", paddingTop: 0 }}
                    >
                      {counterType === "counter" ? (
                        props.nextdueat > 0 ? (
                          <Grid item xs={6} style={{ paddingTop: "17px" }}>
                            <FormControl variant="outlined" xs={6} sx={{}}>
                              <InputLabel>{"Zählerstand"}</InputLabel>
                              <OutlinedInput
                                onChange={handleNextRepititionCycleChange}
                                value={nextRepititionCycles}
                                error={
                                  !!nextError || nextRepititionCycles === 0
                                }
                                helperText={
                                  nextError || nextRepititionCycles === 0
                                }
                                label={"Zählerstand"}
                                variant="outlined"
                                endAdornment={
                                  <div style={{ color: "gray" }}>
                                    {counterUnit}
                                  </div>
                                }
                              />
                              <Typography
                                variant="body2"
                                color="textSecondary"
                                style={{
                                  color: "red",
                                  marginTop: "4px",
                                  fontSize: "10px",
                                  fontWeight: "200",
                                  lineHeight: "1.1"
                                }}
                              >
                                {nextError}
                              </Typography>
                            </FormControl>
                          </Grid>
                        ) : (
                          ""
                        )
                      ) : (
                        ""
                      )}

                      <Grid item xs={6} style={{ paddingTop: "17px" }}>
                        {props.nextdueat <= 0 ? (
                          ""
                        ) : (
                          <TextField
                            id="date"
                            label={"Datum"}
                            sx={{ width: "100%" }}
                            type="date"
                            defaultValue={nextDate}
                            onChange={handleNextDateChange}
                            // className={_s(Theme247.inputField)}
                            InputLabelProps={{
                              shrink: true
                            }}
                            inputProps={{
                              min: new Date().toISOString().split("T")[0] // ✅ Only allow future (and today) dates
                            }}
                            // disabled={
                            //   props && props?.pageType == "edit" ? true : false
                            // }
                            variant="outlined"
                          />
                        )}
                      </Grid>
                    </Grid>
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div style={{ marginTop: "36px" }}></div>

              <Accordion
                className="sigAccordian protokol-accordian"
                defaultExpanded
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1-content"
                  id="panel1-header"
                >
                  <Typography variant="h1" sx={{ color: "#38748D" }}>
                    {"Bestätigung"}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Grid
                    container
                    spacing={3}
                    direction="row"
                    justifyContent="space-between"
                  >
                    <Grid item>
                      <div className="MT_desc">
                        Geben Sie Ihren Namen ein, um das Report zu
                        unterschreiben.
                      </div>
                    </Grid>

                    <Grid container spacing={3} sx={{ paddingLeft: "24px" }}>
                      <Grid item xs={6} sx={{ paddingTop: "16px !important" }}>
                        <FormControl
                          sx={{ margin: 0 }}
                          variant="standard"
                          fullWidth
                        >
                          <TextField
                            id="date"
                            label={"Datum und Uhrzeit"}
                            sx={{ width: "100%" }}
                            type="date"
                            defaultValue={createdDate}
                            onChange={handleCreatedDateChange}
                            // className={_s(Theme247.inputField)}
                            InputLabelProps={{
                              shrink: true
                            }}
                            disabled={
                              props && props?.pageType == "edit" ? true : false
                            }
                            variant="outlined"
                          />
                        </FormControl>
                      </Grid>

                      <Grid item xs={6} style={{ paddingTop: "17px" }}>
                        <TextField
                          className={_s(Theme247.inputField)}
                          onChange={e => {
                            setRealName(e.target.value);
                          }}
                          defaultValue={realName}
                          disabled={
                            props && props?.pageType == "edit" ? true : false
                          }
                          placeholder="Reinhard Müller"
                          label={"Klarname"}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>

                    {hasAuthorSigImage ? (
                      <Grid container spacing={3} sx={{ paddingLeft: "24px" }}>
                        <Grid item xs={6}>
                          {" "}
                          <div className="fullNameSigImg">
                            <img
                              src={
                                props.notification.notification.hasreport[0]
                                  .report.authorsignatureimage.url
                              }
                            />
                            <div>Unterschrift</div>
                          </div>
                        </Grid>
                      </Grid>
                    ) : (
                      <Grid container spacing={3} sx={{ paddingLeft: "24px" }}>
                        <Grid item xs={6}>
                          <TextField
                            className={_s(Theme247.inputField)}
                            onChange={e => {
                              setFullName(e.target.value);
                            }}
                            value={fullname}
                            label={"Vorname und Nachname eingeben..."}
                            variant="outlined"
                            error={fullname === ""}
                          />
                        </Grid>

                        <Grid item xs={6}>
                          {" "}
                          <div className="fullNameSig">{fullname}</div>
                        </Grid>
                      </Grid>
                    )}
                  </Grid>
                </AccordionDetails>
              </Accordion>

              <div style={{ marginTop: "36px" }}></div>

              <Grid container spacing={3}>
                <Grid item xs={6}>
                  {noti_loader ? (
                    <CircularProgress className={classes.progressIndicator} />
                  ) : (
                    ""
                  )}
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    disabled={
                      noti_loader ||
                      (!hasAuthorSigImage && fullname.length === 0) ||
                      createdDate === "" ||
                      (counterType === "counter" &&
                        (nextRepititionCycles === 0 || nextError !== ""))
                    }
                    onClick={submitForm}
                  >
                    {"SPEICHERN"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </section>
    </>
  );
});
